export enum ECheckpointsPerm {
    CHECKPOINTS_VIEW = 'checkpoints_view',
    CHECKPOINTS_DELETE = 'checkpoints_delete',
    CHECKPOINTS_EDIT = 'checkpoints_edit'
}
